import { Autocomplete, InputAdornment, MenuItem, TextField, Select, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ZipcodesWithCountryProps } from '../../pages/get-quote/models';
import { actionTypes } from '../../modules/auth/redux/PagesRedux';
import { isTokenExp } from '../../helpers/isTokenExp';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import { KTSVG } from '../../../_metronic/helpers';
import { NoOptionsText, PaperStyled } from './LTLAndVolumeTLPages.styled';
import { RootState } from '../../../setup/redux/RootReducer';
import { portsModel } from '../PagesModels';
import ShippingLocationsModal from '../ShippingLocationsModal/ShippingLocationsModal';
import { IconButtonStyled } from './ZipcodesWithCountry.styled';
import RemarksMessageModal from '../ShippingLocationsPage/Modals/RemarksMessageModal';
import { sanitizeZipcode } from '../../helpers/sanitizeZipcode';
import { getCountriesWithoutZipcodes } from '../../constants/countries';

let cancelToken
const GET_ZIPCODES = '/api/v1/tools/zipcodes'
const GET_SL = '/api/v1/database/shippinglocation'
const GET_CITIES = '/api/v1/tools/cities'

const ZipcodesWithCountry = React.memo(({data, setData, countryOptions, setDataFormik, valueName, userData, error, touched, setFieldTouched, zipcodeLocal, setZipcodeLocal, drayage, editSL, editVendor, forNewBooking, formFor, disabled, setOpenClearRateToEditModal, formikValues, mode, forStops, forDrayage, setFieldError, shippingLocation, setShippingLocation, forVendorRequest, formDisabled}: ZipcodesWithCountryProps) => {
    const ports = useSelector<any>((store) => store.pages.drayagePorts) as portsModel
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const [openShippingLocationsModal, setOpenShippingLocationsModal] = useState(false)
    const [openRemarksMessageModal, setOpenRemarksMessageModal] = useState(false)

    const useStyles = makeStyles({
        textField: {
            backgroundColor: 'white',
            border: (error && touched) ? '1px solid #F1416C !important' : '1px solid #E4E6EF !important',
            borderTopRightRadius: '0.475rem',
            borderBottomRightRadius: '0.475rem',
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                border: 'none'
            },
            "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                border: 'none'
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
                color: "#5E6278"
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: 'none',
            },
            "& .MuiOutlinedInput-root":{
                color: "#5E6278"
            },
        },
        select: !forNewBooking ? {
            backgroundColor: '#EFF2F5',
            border: '1px solid #E4E6EF',
            borderRight: 'none',
            borderRadius: '0.475rem !important',
            borderTopRightRadius: '0 !important',
            borderBottomRightRadius: '0 !important',
            height: fontSize === 9 ? '32px' : fontSize === 11 ? '42px' : 'var(--input-height)',
            minWidth: '74px',
            width: '100%',
            '& fieldset': {
                border: 'none',
            },
        } : {
            backgroundColor: '#EFF2F5',
            border: '1px solid #E4E6EF',
            borderRight: 'none',
            borderRadius: '0.475rem !important',
            borderTopRightRadius: '0 !important',
            borderBottomRightRadius: '0 !important',
            height: fontSize === 9 ? '32px' : fontSize === 11 ? '42px' : 'var(--input-height)',
            minWidth: '',
            maxWidth: '71px',
            width: '100%',
            '& fieldset': {
                border: 'none',
            }
        },
        height: {
            height: fontSize === 9 ? '30px' : fontSize === 11 ? '40px' : fontSize === 13 ? '28px' : 'var(--input-height)',
        },
        list: {
            "& li": {
                fontFamily: 'Poppins',
                color: '#63627D',
                fontWeight: 500,
                fontSize: fontSize
            },
        },
    })

    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const dispatch = useDispatch()
    const classes = useStyles()
    const isDrayageMode = drayage || mode?.shipmentCategory === 'Drayage' || forDrayage

    const menuProps = {
        classes: {
            list: classes.list
        }
    }

    const getCountryISO3Code = (countryCode: string) => {
        if (!countryCode) return 'USA' // default fallback
        
        if (countryCode.length === 3) {
            // Already ISO3Code format
            return countryCode
        } else if (countryCode.length === 2) {
            // Convert from ISO2Code to ISO3Code
            const countryData = countryOptions?.find(c => c.Code === countryCode)
            return countryData?.CodePrimus || 'USA'
        }
        return 'USA'
    }

    const getData = async (showAllCities = false) => {
        function isCharacterALetter(char){
            return (/[a-zA-Z]/).test(char)
        }        
        // setDataFormik(`${formFor}.city`, data.City || "")

        let firstLetter = zipcodeLocal.charAt(0)

        //CALLS
        setLoading(true)

        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel('Operation canceled due to new request.')
        }
      
        cancelToken = axios.CancelToken.source()

        if(data.Country === 'Port'){
            setOptions(
              ports
                .filter(port => port.name?.toLowerCase().includes(zipcodeLocal?.toLowerCase()) || port.postalCode?.toLowerCase().includes(zipcodeLocal?.toLowerCase()))
                .sort((a, b) => (a.literal || a.name || '').localeCompare(b.literal || b.name || ''))
            )
            setOpen(true)
        }else{
            try {
                const isCountryWithoutZipcodes = getCountriesWithoutZipcodes().includes(data.Country)

                // Only call zipcodes endpoint for countries WITH zipcodes
                const zipcodes = !isCountryWithoutZipcodes ? await axios.get(GET_ZIPCODES, {
                    cancelToken: cancelToken.token,
                    params: {
                        search: zipcodeLocal,
                        searchBy: !isCharacterALetter(firstLetter) && (data.Country === 'US' || data.Country === 'MX') ? 'zipcode' : 'all',
                        countryCode: data.Country,
                        limit: 50
                    }
                }) : {} as any

                const shippingLocations = !editSL && !forNewBooking ? await axios.get(GET_SL, {
                    cancelToken: cancelToken.token,
                    params: {
                        search: zipcodeLocal,
                        country: data.Country,
                        active: true
                    }
                }) : {} as any

                // Only call cities endpoint for countries WITHOUT zipcodes
                // Note: we call cities for ALL cases where country has no zipcodes (including editSL and forNewBooking)
                const cityLocations = isCountryWithoutZipcodes ? await axios.get(GET_CITIES, {
                    cancelToken: cancelToken.token,
                    params: {
                        countryCode: getCountryISO3Code(data.Country)
                    }
                }) : {} as any

                //SAVE RESULTS
                const resultsZipcodes = zipcodes?.data?.data?.results || []
                const resultsSL = shippingLocations?.data?.data?.results || []
                const resultsCityLocations = cityLocations?.data?.data?.results || []

                //DEDUPLICATE: filter out entries with empty stateCode when a complete duplicate with stateCode exists for the same city
                const deduplicateByCity = (items) => items.filter((item, _index, arr) => {
                    if (!item.stateCode && arr.some(other =>
                        other !== item &&
                        (other.city === item.city || other.cityAlias === item.cityAlias) &&
                        other.stateCode
                    )) {
                        return false
                    }
                    return true
                })
                const deduplicatedZipcodes = deduplicateByCity(resultsZipcodes)
                const deduplicatedCityLocations = deduplicateByCity(resultsCityLocations)

                //NORMALIZE OBJECTS
                const shippingLocationsNormalized = resultsSL.map(result => {
                    return {
                        ...result,
                        literal: `${result?.code ? `[${result.code}] ` : ''}${result?.name}. ${result?.city}, ${result.state} ${result.zipcode}`,
                        postalCode: result?.zipcode,
                        stateCode: result?.state,
                        cityAlias: result?.city,
                        name: result?.name,
                        isSL: true
                    }
                })
                const zipcodesNormalized = deduplicatedZipcodes.map(result => {
                    return {
                        ...result,
                        isZipcode: true
                    }
                })

                const cityLocationsNormalized = deduplicatedCityLocations
                    .filter(result => showAllCities || result.city?.toLowerCase().includes(zipcodeLocal?.toLowerCase()))
                    .map(result => {
                        return {
                            ...result,
                            literal: `${result.city}${result.stateFullName ? `, ${result.stateFullName}` : ''}`,
                            cityAlias: result.city,
                            stateCode: result.stateCode || '',
                            postalCode: result.postalCode || '',
                            isCity: true
                        }
                    })

                // For countries without zipcodes, always include cities in results
                // For editSL: zipcodes + cities (for countries without zipcodes)
                // For forNewBooking: zipcodes + cities (but not shipping locations)
                // For normal mode: zipcodes + shipping locations + cities
                let arrayJoined = editSL
                    ? [...zipcodesNormalized, ...cityLocationsNormalized]
                    : forNewBooking
                        ? [...zipcodesNormalized, ...cityLocationsNormalized]
                        : [...zipcodesNormalized, ...shippingLocationsNormalized, ...cityLocationsNormalized]

                //SAVE NORMALIZED OBJECTS IN OPTIONS ARRAY
                setOptions(arrayJoined)
            } catch (error) {
                setLoading(false)
                if(error.message === 'Network Error') {
                    dispatch({type: actionTypes.SetAxiosErrors, payload: 'Network Error on Zipcodes, check your internet connection and try again'})
                }else{
                    if(error?.response?.data?.error?.message.length){
                        if(error?.response?.status === 401){
                            isTokenExp()
                        }else{
                            dispatch({type: actionTypes.SetAxiosErrors, payload: error?.response?.data?.error?.message})
                        }
                    }
                }
            }
        }

        setLoading(false)
    }

    useEffect(() => {
        if(editSL){
            setDataFormik('country', data?.Country)
            setDataFormik('city', data?.City)
            setDataFormik('state', data?.State)
            setDataFormik('zipcode', data?.Zipcode)
        }else if(editVendor){
            setDataFormik(`${valueName}.city`, data?.City)
            setDataFormik(`${valueName}.state`, data?.State)
            setDataFormik(`${valueName}.zipcode`, data?.Zipcode)
            setDataFormik(`${valueName}.country`, data?.Country)
        }else if(forNewBooking){
            // Handle forNewBooking: set zipcodeLocal for countries without zipcodes
            const isCountryWithoutZipcode = getCountriesWithoutZipcodes().includes(data?.Country)
            const inferredIsCity = isCountryWithoutZipcode && data?.City && !data?.Zipcode

            if((data?.isCity || inferredIsCity) && data?.City){
                // For countries without zipcodes, show the city name in the input
                setZipcodeLocal(data.isSL ? `${data.Name}. ${data.City}${data.State ? ', ' + data.State : ''}` : `${data.City}${data.State ? ', ' + data.State : ''}`)
            } else if(data?.Zipcode){
                // For countries with zipcodes, show the formatted zipcode
                setZipcodeLocal(data?.isSL
                    ? (`${data?.Name}. ${data?.City}, ${data?.State} ${data?.Zipcode}`)
                    : (`${data?.City}${data?.City ? ', ' : ''}${data?.State ? data?.State+' ' : ''}${data?.Zipcode}`)
                )
            }
        }else if(!forNewBooking){
            setDataFormik(`${valueName}.City`, data?.City || '')
            setDataFormik(`${valueName}.Country`, data?.Country || '')
            setDataFormik(`${valueName}.Name`, data?.Name || '')
            setDataFormik(`${valueName}.State`, data?.State || '')
            setDataFormik(`${valueName}.Zipcode`, data?.Zipcode || '')
            setDataFormik(`${valueName}.isZipcode`, data?.isZipcode || '')
            setDataFormik(`${valueName}.isCity`, data?.isCity || '')
            setDataFormik(`${valueName}.isPort`, data?.isPort || '')
            setDataFormik(`${valueName}.isSL`, data?.isZipcode || '')
            setDataFormik(`${valueName}.id`, data?.id || '')
            setDataFormik(`${valueName}.remarks`, data?.Remarks || '')
            setDataFormik(`${valueName}.OpenTime`, data?.OpenTime || '')
            setDataFormik(`${valueName}.CloseTime`, data?.CloseTime || '')
            setDataFormik(`${valueName}.IATACode`, data?.IATACode || '')

            if(data.address1){
                setDataFormik(`${valueName}.address1`, data?.address1 || '')
            }
            if(data.address2){
                setDataFormik(`${valueName}.address2`, data?.address2 || '')
            }
            // Note: zipcodeLocal is set by the useEffect([data.Zipcode, data.City, data.isCity, data.Country]) below

        }
        else if(formFor == 'billToData') {
            // console.log(data?.City, )
            setDataFormik(`city`, data?.City || '')
            setDataFormik(`state`, data?.State || '')
            setDataFormik(`zipcode`, data?.Zipcode || '')
            setDataFormik(`country`, data?.Country || '')

            // setDataFormik(`${valueName}.Country`, data?.Country || '')
            // setDataFormik(`${valueName}.Name`, data?.Name || '')
            // setDataFormik(`${valueName}.State`, data?.State || '')
            // setDataFormik(`${valueName}.Zipcode`, data?.Zipcode || '')
            // setDataFormik(`${valueName}.isZipcode`, data?.isZipcode || '')
            // setDataFormik(`${valueName}.isPort`, data?.isPort || '')
            // setDataFormik(`${valueName}.isSL`, data?.isZipcode || '')
            // setDataFormik(`${valueName}.id`, data?.id || '')
            // setDataFormik(`${valueName}.remarks`, data?.Remarks || '')
            // setDataFormik(`${valueName}.OpenTime`, data?.OpenTime || '')
            // setDataFormik(`${valueName}.CloseTime`, data?.CloseTime || '')
            // setDataFormik(`${valueName}.IATACode`, data?.IATACode || '')
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if(!data?.Country && !data?.Country?.length){
            setData({
                ...data,
                Country: getCountryOptionsAllowed().length > 0
                            ? (getCountryOptionsAllowed().find(country => country?.Code === 'US') ? 'US' : getCountryOptionsAllowed()[0].Code)
                            : 'US'
            })
        } 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.Country])

    useEffect(() => {
        // Check if this is a country without zipcodes
        const isCountryWithoutZipcode = data.Country ? getCountriesWithoutZipcodes().includes(data.Country) : false
        const inferredIsCity = isCountryWithoutZipcode && data.City && !data.Zipcode

        // Don't call getData for cities in countries without zipcodes IF we already have a city selected
        // This prevents race conditions when coming from quotes
        // Use includes() instead of strict equality to handle formatted strings like "Paramaribo, Paramaribo"
        if((data.isCity || inferredIsCity) && zipcodeLocal && data.City && zipcodeLocal.includes(data.City)){
            return // Don't search, we already have the city
        }

        if(data.Country === 'Port'){
            getData()
        }else if(zipcodeLocal && zipcodeLocal.length >= 4){
            const expectedValue = data.isZipcode
                ? (`${data.City}${data.City ? ', ' : ''}${data.State ? data.State+' ' : ''}${data.Zipcode}`)
                : data.isSL ? (`${data?.Name}. ${data?.City}, ${data.State} ${data.Zipcode}`) : (`${data?.City}, ${data.State} ${data.Zipcode}`)
            const expectedValueNoZip = data.isZipcode
                ? (`${data.City}${data.State ? ', ' + data.State : ''}`)
                : data.isSL ? (`${data?.Name}. ${data?.City}${data.State ? ', ' + data.State : ''}`) : (`${data?.City}${data.State ? ', ' + data.State : ''}`)
            if(zipcodeLocal !== expectedValue && zipcodeLocal !== expectedValueNoZip){
                getData()
            }
        }else{
            setOptions([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipcodeLocal, data.Country, ports])

    useEffect(() => {
        // Check if this is a country without zipcodes - infer isCity if city exists but no zipcode
        const isCountryWithoutZipcode = getCountriesWithoutZipcodes().includes(data.Country)
        const inferredIsCity = isCountryWithoutZipcode && data.City && !data.Zipcode

        if((data.isCity || inferredIsCity) && data.City){
            // For countries without zipcodes, show city with state
            setZipcodeLocal(data.isSL ? `${data.Name}. ${data.City}${data.State ? ', ' + data.State : ''}` : `${data.City}${data.State ? ', ' + data.State : ''}`)
        } else if(data.Zipcode && data.Zipcode.length){
            setZipcodeLocal(data.isZipcode
                ? (`${data.City}${data.City ? ', ' : ''}${data.State ? data.State+' ' : ''}${data.Zipcode}`)
                : data.isSL ? (`${data?.Name}. ${data?.City}, ${data.State} ${data.Zipcode}`) : (`${data?.City} , ${data.State} ${data.Zipcode}`)
            )
        } else if(data.City){
            setZipcodeLocal(data.isZipcode
                ? (`${data.City}${data.State ? ', ' + data.State : ''}`)
                : data.isSL ? (`${data?.Name}. ${data?.City}${data.State ? ', ' + data.State : ''}`) : (`${data?.City}${data.State ? ', ' + data.State : ''}`)
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.Zipcode, data.City, data.isCity, data.Country])

    useEffect(() => {
        if(options.length > 0 && open === false){
            setLoading(true)

            const cleanPostalCode = sanitizeZipcode(options[0]?.postalCode)
            setData({
                ...data,
                'Zipcode': cleanPostalCode,
                'State': options[0]?.stateCode,
                'City': options[0]?.cityAlias || options[0]?.city,
                'isSL': options[0]?.isSL || false,
                'isPort': options[0]?.isPort || false,
                'isZipcode': options[0]?.isZipcode || false,
                'isCity': options[0]?.isCity || false,
                'Name': options[0]?.name || data?.Name || formikValues[formFor]?.name || formikValues[valueName]?.name || undefined,
                'id': options[0]?.isSL ? options[0].id : 0,
                'Remarks': options[0].remarks,
                'OpenTime': options[0].opentime,
                'CloseTime': options[0].closetime,
                'IATACode' : options[0]?.IATA || ''
            })

            if(forVendorRequest){
                setDataFormik(`${valueName}.address1`, options[0]?.address || "")
                setDataFormik(`${valueName}.address2`, options[0]?.address1 || "")
            }

            if(valueName){
                setFieldError(`${valueName}.Zipcode`, '')
            }
            
            if(forNewBooking){
                setDataFormik(`${formFor}.city`, options[0]?.cityAlias || options[0]?.city || "")
                setDataFormik(`${formFor}.state`, options[0]?.stateCode || "")
                setDataFormik(`${formFor}.zipcode`, cleanPostalCode || "")
                setDataFormik(`${formFor}.name`, options[0]?.name || data?.Name || formikValues[formFor]?.name || formikValues[valueName]?.name || "")
                setDataFormik(`${formFor}.isCity`, options[0]?.isCity || false)
            }
            setOptions([])
            setLoading(false)

            if(options[0]?.alertUser && options[0]?.remarks){
                setOpenRemarksMessageModal(true)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options])

    const getCountryOptionsAllowed = () => {
        let defaultCountries = userData?.defaultCountries
        let countriesArrayLocal = []
        defaultCountries?.forEach(country => {
            let allowedCountry = countryOptions?.find(c => c.CodePrimus === country)
            if(allowedCountry?.CodePrimus) {
                countriesArrayLocal?.push(allowedCountry)
            }
        })
        return countriesArrayLocal.sort((a, b) => a.Name.localeCompare(b.Name))
    }

    useEffect(() => {
        getCountryOptionsAllowed()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const isPort = drayage && data?.Country === 'Port'
    const isCountryWithoutZipcodes = getCountriesWithoutZipcodes().includes(data?.Country)
    const allowAutoSelect = !isPort && !isCountryWithoutZipcodes

    return (
        <>
            {/* col-xl-5 col-md-7 col-sm-8 mb-2 */}
            <div className={editSL || editVendor || forNewBooking || forStops ? "" : !forDrayage ? 'col-sm-8 col-md-7 col-xl-3' : 'col-xl-5 col-md-7 col-sm-8 mb-5'}>
                <div className='d-flex'>
                    <div style={{width: !forNewBooking ? '100px' : ''}}>
                        <Select
                            readOnly={formikValues?.carrierInformation?.name || formDisabled ? true : false}
                            onClick={() => { 
                                if((formikValues?.carrierInformation?.name && !disabled) || formDisabled){
                                    setOpenClearRateToEditModal(true)
                                }
                            }}
                            onChange={(e) => {
                                setData({
                                    ...data,
                                    Country: e.target.value,
                                    City: '',
                                    Name: '',
                                    State: '',
                                    Zipcode: '',
                                    isSL: false,
                                    isZipcode: false,
                                    isPort: e.target.value == 'Port' ? true : false,
                                    OpenTime: '',
                                    CloseTime: '',
                                    IATACode: ''
                                })
                                setZipcodeLocal('')
                                if(forNewBooking){
                                    setDataFormik(`${formFor}.country`, e.target.value !== 'Port' ? e.target.value : 'US'  || "US")
                                }
                                if(shippingLocation?.id){
                                    setShippingLocation({
                                        ...shippingLocation,
                                        id: null
                                    })
                                    setDataFormik(`${formFor}.id`, null)
                                }
                                if(forVendorRequest){
                                    setDataFormik(`${valueName}.address1`, '')
                                    setDataFormik(`${valueName}.address2`, '')
                                }
                            }}
                            defaultValue={data?.Country || (getCountryOptionsAllowed().length > 0
                                        ? (getCountryOptionsAllowed().find(country => country?.Code === 'US') ? 'US' : getCountryOptionsAllowed()[0]?.Code)
                                        : 'US')}
                            renderValue={() => data?.isPort ? <DirectionsBoatIcon className="text-success" style={{height: '20px !important', width: '20px !important'}}/> : <img className='m-0' alt='flag' src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${data.Country}.svg`} width="24"/>}
                            className={`${classes.select} selectCountry`}
                            MenuProps={menuProps}
                            inputProps={{ tabIndex: 1 }}
                            value={data?.Country || 'US'}
                            disabled={disabled}
                        >
                            {
                                isDrayageMode ? 
                                    ['US', 'Port'].map((country, index) => {
                                        return (<MenuItem key={index} value={country}>{country === 'US' ? 'United States' : country}</MenuItem>)
                                    })
                                : getCountryOptionsAllowed().length > 0
                                ? getCountryOptionsAllowed()?.map((country, index) => {
                                    return (<MenuItem key={index} value={country?.Code}>{country?.Name}</MenuItem>)
                                })
                                : countryOptions?.map((country, index) => {
                                    return (<MenuItem key={index} value={country?.Code}>{country?.Name}</MenuItem>)
                                })
                            }
                        </Select>
                    </div>
                    <div className="w-100">   
                        <Autocomplete
                            readOnly={formikValues?.carrierInformation?.name || formDisabled ? true : false}
                            disabled={disabled}
                            freeSolo={isDrayageMode && data?.Country === 'Port'}
                            onBlur={() => setFieldTouched(valueName, true)}
                            autoSelect={allowAutoSelect}
                            blurOnSelect
                            autoComplete={false}
                            autoHighlight={allowAutoSelect}
                            className='dropdownContainer w-100'
                            getOptionLabel={(option) => option.literal ? option.literal : option || ""}
                            filterOptions={(options) => options}
                            options={options}
                            selectOnFocus
                            openOnFocus={isDrayageMode && data?.Country === 'Port'}
                            handleHomeEndKeys
                            forcePopupIcon={false}
                            inputValue={zipcodeLocal}
                            onFocus={() => {
                                if(isDrayageMode && data?.Country === 'Port'){
                                    getData()
                                }else if(isCountryWithoutZipcodes){
                                    getData(true)
                                }
                            }}
                            onOpen={() => {
                                if(data?.Country !== 'Port'){
                                    setLoading(true)
                                }
                                setOpen(true)
                            }}
                            onClose={() => {
                                setLoading(false)
                                setOpen(false)
                                if(data?.Country !== 'Port'){ 
                                    setOptions([])
                                }                               
                            }}
                            clearOnBlur={false}
                            onInputChange={(e, rawValue) =>  {
                                const value = rawValue?.replace(/[\u200B-\u200D\uFEFF\u00AD]/g, '') || ''
                                if(shippingLocation?.id){
                                    setShippingLocation({
                                        ...shippingLocation,
                                        id: null
                                    })
                                    setDataFormik(`${formFor}.id`, null)
                                }

                                if(e?.type === "change"){
                                    setZipcodeLocal(value)
                                }

                                if(value === "" || value.length < 10){
                                    setData({...data,
                                        'Zipcode': undefined,
                                        'State': undefined,
                                        'City': undefined,
                                        'isSL': undefined,
                                        'isZipcode': undefined,
                                        'isPort': data?.Country === 'Port' ? true : undefined,
                                        'Name': undefined,
                                        'id': undefined,
                                        'OpenTime': undefined,
                                        'CloseTime': undefined,
                                        'IATACode': undefined
                                    })
                                }

                                if(value === ''){
                                    if(forNewBooking){
                                        setDataFormik(`${formFor}.city`, "")
                                        setDataFormik(`${formFor}.state`, "")
                                        setDataFormik(`${formFor}.zipcode`, "")
                                    }

                                    if(forVendorRequest){
                                        setDataFormik(`${valueName}.address1`, '')
                                        setDataFormik(`${valueName}.address2`, '')
                                    }
                                }
                            }}
                            onChange={(event, value) => {
                                const cleanPostalCode = sanitizeZipcode(value?.postalCode)
                                setData({...data, 
                                    'Zipcode': cleanPostalCode || '',
                                    'State': value?.stateCode || '',
                                    // 'City': value?.cityAlias || value?.city,
                                    'City': value?.isPort ? value?.name : (value?.cityAlias || value?.city),
                                    'isSL': value?.isSL || false,
                                    'isZipcode': value?.isZipcode || false,
                                    'isCity': value?.isCity || false,
                                    'isPort': data.Country === 'Port' ? true : (value?.isPort || false),
                                    'Name': value?.isPort ? undefined : value?.name || formikValues[valueName]?.name || undefined,
                                    'id': value?.isSL ? value?.id : 0,
                                    'CountryPort': value?.country,
                                    'Remarks': value?.remarks,
                                    'OpenTime': value?.opentime,
                                    'CloseTime': value?.closetime,
                                    'IATACode' : value?.IATA || ''
                                })

                                // Set the input value for cities (countries without zipcodes)
                                if(value?.isCity) {
                                    // Show "City, State" only if they're different, otherwise just "City"
                                    const cityName = value?.city || ''
                                    const stateName = value?.stateFullName || value?.stateCode || ''
                                    const displayValue = stateName && stateName.toLowerCase() !== cityName.toLowerCase()
                                        ? `${cityName}, ${stateName}`
                                        : cityName
                                    setZipcodeLocal(displayValue)
                                }

                                if(valueName){
                                    setFieldError(`${valueName}.Zipcode`, '')
                                }

                                if(forVendorRequest){
                                    setDataFormik(`${valueName}.address1`, value?.address)
                                    setDataFormik(`${valueName}.address2`, value?.address1)
                                }

                                if(forNewBooking && formFor !== 'collect'){
                                    setDataFormik(`${formFor}.city`, value?.isPort ? value?.name : (value?.cityAlias || value?.city  || ""))
                                    setDataFormik(`${formFor}.state`, value?.stateCode || "")
                                    setDataFormik(`${formFor}.zipcode`, cleanPostalCode || "")
                                    setDataFormik(`${formFor}.isCity`, value?.isCity || false)
                                    if(data.Country === 'Port'){
                                        setDataFormik(`${formFor}.country`, value?.country)
                                    }
                                }
                                if(forNewBooking && formFor == 'collect'){
                                    setDataFormik(`city`, value?.isPort ? value?.name : (value?.cityAlias || value?.city  || ""))
                                    setDataFormik(`state`, value?.stateCode || "")
                                    setDataFormik(`zipcode`, cleanPostalCode || "")
                                    setDataFormik(`isCity`, value?.isCity || false)
                                    if(data.Country === 'Port'){
                                        setDataFormik(`country`, value?.country)
                                    }
                                }

                                if(value?.isSL && value?.alertUser && value?.remarks){
                                    setOpenRemarksMessageModal(true)
                                }
                            }}
                            onKeyPress={(event) => {
                                if(valueName) {
                                    setFieldError(`${valueName}.Zipcode`, '')
                                }
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    return false;
                                }
                            }}
                            renderInput={params => {
                                return (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        autoComplete='new-password'
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButtonStyled
                                                        tabIndex={-1}
                                                        disabled={loading || forNewBooking || forStops}
                                                        alldisabled={disabled ? 'true' : 'false'}
                                                        onClick={() => {
                                                            if(formDisabled){
                                                                setOpenClearRateToEditModal(true)
                                                            }else{
                                                                setOpenShippingLocationsModal(true)
                                                            }
                                                        }}
                                                    >
                                                        {loading ? <div className='d-flex align-items-center'><CircularProgress color="inherit" size={15} /></div> : <KTSVG path='/media/icons/bootstrap/search.svg' className='svg-icon svg-icon-6' style={{color: '#a1a5b7'}}/>}
                                                    </IconButtonStyled>
                                                </InputAdornment>
                                            ),
                                            className: classes.height,
                                            style: {fontSize: 14, fontFamily: 'Poppins', fontWeight: 500, paddingRight: 9, color:"#5E6278 !important", borderTopLeftRadius: 0, borderBottomLeftRadius: 0, backgroundColor: disabled ? '#EFF2F5' : 'white'},
                                        }}
                                        className={classes.textField}
                                        onClick={() => {
                                            if((formikValues?.carrierInformation?.name && !disabled) || formDisabled){
                                                setOpenClearRateToEditModal(true)
                                            }
                                        }}
                                    />
                                );
                            }}
                            renderOption={(props, option) => (
                                <li key={option} {...props}>
                                    {option.isZipcode && <KTSVG path='/media/icons/bootstrap/geo-alt.svg' className='svg-icon svg-icon-5 me-2 text-primary'/>}
                                    {option.isSL && <KTSVG path='/media/icons/bootstrap/building.svg' className='svg-icon svg-icon-5 me-2 text-danger'/>}
                                    {option.isPort && <DirectionsBoatIcon className="me-1 text-success" style={{height: '18px', width: '18px'}}/>}
                                    {option.isCity && <KTSVG path='/media/icons/bootstrap/geo-alt.svg' className='svg-icon svg-icon-5 me-2 text-primary'/>}
                                    {option.literal}
                                </li>
                            )}
                            PaperComponent={({ children }) => (
                                <PaperStyled fontSize={fontSize}>
                                    {children}
                                </PaperStyled>
                            )}
                            noOptionsText={<NoOptionsText>No options</NoOptionsText>}
                        />
                    </div>
                </div>
                <div className='d-flex'>
                    <div style={{width: '92px'}}>
                        
                    </div>
                    <div>
                        {error && touched
                            ? <small className="text-danger">{error}</small>
                            : null
                        }
                    </div>
                </div>
            </div>
            <ShippingLocationsModal
                open={openShippingLocationsModal}
                setOpen={setOpenShippingLocationsModal}
                data={data}
                setData={setData}
                forVendorRequest={forVendorRequest}
                valueName={valueName}
                setFormikValues={setDataFormik}
                setOpenRemarksMessageModal={setOpenRemarksMessageModal}
                forDrayage={data?.isPort || false}
                userData={userData}
            />
            <RemarksMessageModal
                open={openRemarksMessageModal}
                setOpen={setOpenRemarksMessageModal}
                formik={formikValues}
                formFor={valueName}
            />
        </>
    );
});

export default ZipcodesWithCountry;